<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { tooltip } from '@svelte-plugins/tooltips';
    import { openModal } from 'svelte-modals';

    import TemplateStandard from '../TemplateStandard.svelte';
    import { debug, mainMenu } from '../../../stores/store';
    import TemplateHeaderTrio from '../TemplateHeaderTrio.svelte';
    import IconAdd from '../Icons/IconAdd.svelte';
    import { WidgetManager } from './WidgetManager';
    import { availableWidgets } from '../../components/Dashboard/availableWidgets';
    import { WidgetApi } from './WidgetApi';
    import ModalWidgetAdd from './ModalWidgetAdd.svelte';
    import WidgetList from './WidgetList.svelte';
    import DashboardFilter from './DashboardFilter.svelte';
    import Select from '../Select.svelte';
    import { filter } from '../../../stores/filter';
    import IconPending from '../Icons/IconPending.svelte';
    import { WidgetTemplateList } from './WidgetTemplateList/WidgetTemplateList';
    import { api } from '../../../stores/api';
    import ModalCustom from '../Modals/ModalCustom.svelte';
    import WidgetTemplateListComponent from './WidgetTemplateList/WidgetTemplateListComponent.svelte';
    import { app } from '../../../stores/app';
    import StyleLikeFilterItem from '../StyleLikeFilterItem.svelte';
    import ButtonAddSomething from '../ButtonAddSomething.svelte';
    import { MenuContextCustomActions } from '../../components/MenuDropdown/MenuContextCustomActions';
    import MenuContextIcon from '../../components/MenuDropdown/MenuContext/MenuContextIcon.svelte';
    import IconListAlt from '../Icons/IconListAlt.svelte';
    import IconStylus from '../Icons/IconStylus.svelte';
    import InputTextInline from '../InputTextInline.svelte';
    import ButtonMain from '../ButtonMain.svelte';
    import IconRemove from '../Icons/IconRemove.svelte';
    import WarningColor from '../WarningColor.svelte';
    import TooltipTemplateReadonly from './TooltipTemplateReadonly.svelte';
    import IconCopy from '../Icons/IconCopy.svelte';
    import { get } from 'svelte/store';

    let currentDashboardKey: number = 12;
    let loadingCurrentDashboard: boolean = true;
    let editTemplateNameEditMode: boolean = false;
    let widgetManager = new WidgetManager(new WidgetApi(currentDashboardKey, $api));
    let widgetTemplateList: WidgetTemplateList = new WidgetTemplateList(
        $api,
        $app.account.getWebuserId()
    );

    onMount(() => {
        $mainMenu.fullscreenMode = true;
        $mainMenu.currentPage = 'PageDashboard';

        (async () => {
            loadingCurrentDashboard = true;
            await widgetTemplateList.load().catch(e => {
                console.error('WidgetTemplateList', e);
            });
            if (widgetTemplateList.getTemplates().length === 0) {
                console.log('WidgetTemplateList, no templates, creating one...');
                await widgetTemplateList.createEmptyTemplate();
                await widgetTemplateList.load().catch(e => {
                    console.error('WidgetTemplateList', e);
                });
            }
            await reloadTemplateList(false);
            loadingCurrentDashboard = false;
        })();

        return () => {
            $mainMenu.fullscreenMode = false;
        };
    });

    async function reloadTemplateList(withReload: boolean = true) {
        if (withReload) {
            await widgetTemplateList.load().catch(e => {
                console.error('WidgetTemplateList', e);
            });
        }

        console.log(
            'WidgetTemplateList',
            widgetTemplateList.getCurrentTemplateId(),
            widgetTemplateList.getTemplatesAsItems()
        );

        let currTemplateId = widgetTemplateList.getCurrentTemplateId();
        if (currTemplateId === null) {
            console.log('WidgetTemplateList, no current template');
        } else {
            // updateMenu(menu);
            await reloadCurrentTemplate(currTemplateId, widgetTemplateList.isReadOnly());
        }
    }

    async function reloadCurrentTemplate(selected: number, readonly: boolean = false) {
        // loadingCurrentDashboard = true;
        widgetManager = new WidgetManager(new WidgetApi(selected, $api));
        widgetManager.setAutosave(false);
        await widgetManager.load().catch(e => {
            console.error('WidgetManager', e);
        });
        console.log(
            'WidgetApi, mainQuery, ids',
            widgetManager.mainQuery,
            widgetManager.getComponentIds()
        );
        if (readonly) {
            widgetManager.setAutosave(false);
        } else {
            widgetManager.setAutosave(true);
        }
        updateMenu(menu);
        widgetManager = widgetManager;
        widgetTemplateList = widgetTemplateList;
        // loadingCurrentDashboard = false;
    }

    function onChangeFilters(queries: any) {
        console.log('WidgetApi, PageDashboard, onChangeFilters', queries);
        widgetManager.mainQuery = queries;
        widgetManager.save();
    }

    let menu: MenuContextCustomActions = new MenuContextCustomActions();

    function updateMenu(menu: MenuContextCustomActions) {
        menu.reset();
        menu.addAction({
            id: 'list_template',
            label: $_('show_views_list'),
            disabled: false,
            visible: true,
            icon: IconListAlt,
            onClick: () => {
                console.log('list_template');
                openModal(ModalCustom, {
                    modeView: 'analytics',
                    showButtonOk: false,
                    component: WidgetTemplateListComponent,
                    componentProps: {
                        title: $_('panel') + ' - ' + $_('widoki'),
                        widgetTemplateList: widgetTemplateList,
                        onChange: (templates) => {
                            console.log('ModalCustom, onChange');
                            widgetTemplateList.setTemplates(templates);
                            widgetTemplateList = widgetTemplateList;
                        },
                        onSelect: templateId => {
                            console.log('ModalCustom, onSelect', templateId);
                            loadingCurrentDashboard = true;
                            widgetTemplateList
                                .setCurrentTemplateId(templateId)
                                .then(_ => {
                                    reloadTemplateList().finally(() => {
                                        loadingCurrentDashboard = false;
                                    });
                                })
                                .catch(e => {
                                    console.error('WidgetTemplateList, setCurrentTemplateId', e);
                                    loadingCurrentDashboard = false;
                                });
                        },
                    },
                    onClick: () => {
                        console.log('ModalCustom, onClick');
                        widgetTemplateList = widgetTemplateList;
                    },
                });
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'rename_template',
            label: $_('rename_action'),
            disabled: widgetTemplateList.isReadOnly(),
            visible: true,
            icon: IconStylus,
            onClick: () => {
                console.log('rename_template', editTemplateNameEditMode);
                editTemplateNameEditMode = !editTemplateNameEditMode;
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'add_template',
            label: $_('Dodaj widok'),
            disabled: false,
            visible: true,
            icon: IconAdd,
            onClick: () => {
                console.log('add_template');
                (async () => {
                    loadingCurrentDashboard = true;
                    let template = await widgetTemplateList.createEmptyTemplate();
                    await widgetTemplateList.setCurrentTemplateId(template.id);
                    await reloadTemplateList();
                    loadingCurrentDashboard = false;
                })();
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'copy_template',
            label: $_('Kopiuj widok'),
            disabled: false,
            visible: true,
            icon: IconCopy,
            onClick: () => {
                (async () => {
                    await saveAsOwnTemplate();
                })();
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu.addAction({
            id: 'remove_template',
            label: $_('remove_view'),
            disabled: widgetTemplateList.isReadOnly(),
            visible: true,
            icon: IconRemove,
            onClick: () => {
                console.log('Remove', widgetTemplateList.getCurrentTemplateId());
                let agree = confirm($_('confirm_delete_current_view'));
                if (agree) {
                    loadingCurrentDashboard = true;
                    widgetTemplateList
                        .removeTemplate(widgetTemplateList.getCurrentTemplateId())
                        .then(_ => {
                            widgetTemplateList
                                .load()
                                .then(_ => {
                                    console.log(
                                        'Remove, after load',
                                        widgetTemplateList.getTemplates().map(t => t.label)
                                    );
                                    widgetTemplateList = widgetTemplateList;
                                    if (widgetTemplateList.getTemplates().length > 0) {
                                        let templateId = widgetTemplateList.getTemplates()[0].id;
                                        widgetTemplateList.setCurrentTemplateId(templateId);
                                        reloadCurrentTemplate(templateId);
                                    }
                                })
                                .finally(() => {
                                    loadingCurrentDashboard = false;
                                });
                        })
                        .finally(() => {
                            loadingCurrentDashboard = false;
                        });
                }
            },
            subMenuIsOpen: false,
            visibleInContextMenu: true,
        });
        menu = menu;
    }

    updateMenu(menu);
    //
    // $: console.log(
    //     'PageDashboard',
    //     widgetManager.getComponents().map(c => c.id)
    // );

    $: {
        widgetTemplateList = widgetTemplateList;
        console.log(
            '$widgetTemplateList, widgetTemplateList',
            widgetTemplateList.getCurrentTemplateId()
        );
    }

    $: {
        console.log('$widgetTemplateList, loadingCurrentDashboard', loadingCurrentDashboard);
    }

    function addWidget() {
        openModal(ModalWidgetAdd, {
            availableWidgets: get(availableWidgets),
            onSelect: componentId => {
                let selectedWidget = get(availableWidgets).find(w => w.id === componentId);
                if (selectedWidget) {
                    loadingCurrentDashboard = true;
                    widgetManager
                        .addWidget(selectedWidget)
                        .then(_ => {
                            widgetManager = widgetManager;
                        })
                        .catch(e => {
                            console.error('WidgetManager', e);
                        })
                        .finally(() => {
                            loadingCurrentDashboard = false;
                        });
                } else {
                    console.error('Widget not found', componentId);
                }
            },
        });
    }

    async function createFirstTemplate() {
        loadingCurrentDashboard = true;
        await widgetTemplateList.createEmptyTemplate();
        await reloadTemplateList();
        loadingCurrentDashboard = false;
    }

    async function saveAsOwnTemplate() {
        loadingCurrentDashboard = true;
        let oldTemplate = widgetTemplateList.getCurrentTemplate();
        let newTemplate = await widgetTemplateList.createEmptyTemplate();
        let newWidgetApi = new WidgetApi(newTemplate.id, $api);
        widgetManager.setApi(newWidgetApi);
        widgetManager.setAutosave(true);
        await widgetManager.save();
        await widgetTemplateList.setCurrentTemplateId(newTemplate.id);
        await widgetTemplateList.changeTemplateLabel(
            newTemplate.id,
            oldTemplate?.label + ' (' + $_('kopia') +')' || '(' + $_('brak nazwy') + ')',
            true
        );
        await reloadTemplateList();
        loadingCurrentDashboard = false;
    }
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                <div
                    style="display:flex; flex-direction: row; align-items: center; column-gap: 40px;"
                >
                    <div>{$_('Dashboard')}</div>
                    <div
                        style="display:flex; flex-direction: row; align-items: center; column-gap: 20px;"
                    >
                        {#if widgetTemplateList.getCurrentTemplateId() !== null}
                            <StyleLikeFilterItem mode="vehicle">
                                <div
                                    style="display: flex; align-items: center; column-gap: 8px; padding:3px; min-width: 300px; justify-content: space-between; "
                                >
                                    {#if editTemplateNameEditMode}
                                        <InputTextInline
                                            value={widgetTemplateList.getCurrentTemplate()?.label ||
                                                ''}
                                            disabled={loadingCurrentDashboard}
                                            editMode={true}
                                            showEditIcon={false}
                                            styleMode="blue"
                                            onChange={label => {
                                                console.log('label', label);
                                                loadingCurrentDashboard = true;
                                                widgetTemplateList
                                                    .changeTemplateLabel(
                                                        widgetTemplateList.getCurrentTemplateId(),
                                                        label.toString()
                                                    )
                                                    .then(_ => {
                                                        console.log('template name saved');
                                                        widgetTemplateList = widgetTemplateList;
                                                    })
                                                    .finally(() => {
                                                        editTemplateNameEditMode = false;
                                                        loadingCurrentDashboard = false;
                                                    });
                                            }}
                                        />
                                    {:else}
                                        <div class:disabled={loadingCurrentDashboard}>
                                            <Select
                                                width={'300px'}
                                                useDefaultStyles={false}
                                                disabled={false}
                                                selected={widgetTemplateList
                                                    .getCurrentTemplateId()
                                                    ?.toString()}
                                                items={widgetTemplateList.getTemplatesAsItems()}
                                                onChange={selected => {
                                                    widgetTemplateList.setCurrentTemplateId(
                                                        parseInt(selected)
                                                    );
                                                    reloadCurrentTemplate(parseInt(selected));
                                                    return true;
                                                }}
                                            />
                                        </div>
                                    {/if}
                                    {#if loadingCurrentDashboard}
                                        <div style="display: flex; min-width: 21px;">
                                            <IconPending scale={0.7} spin={true} />
                                        </div>
                                    {:else}
                                        <MenuContextIcon bind:menu />
                                    {/if}
                                </div>
                            </StyleLikeFilterItem>
                            <ButtonAddSomething
                                disabled={loadingCurrentDashboard}
                                text={$_("Add_widget")}
                                on:click={() => {
                                    addWidget();
                                }}
                            />
                            {#if widgetTemplateList.isReadOnly()}
                                <!--                                <span-->
                                <!--                                    use:tooltip={{-->
                                <!--                                        action: 'click',-->
                                <!--                                        content:-->
                                <!--                                            'Możesz wprowadzać tutaj zmiany, ale nie zostaną one zapisane, gdyż widok może być edytowany tylko przez jego autora. Aby móc zapisać zmiany, utwórz własny widok korzystając z opcji KOPIUJ WIDOK z menu kontekstowego.',-->
                                <!--                                        theme: 'lastmile-tooltip-no-events',-->
                                <!--                                        position: 'bottom',-->
                                <!--                                        autoPosition: true,-->
                                <!--                                        maxWidth: 400,-->
                                <!--                                    }}-->
                                <!--                                >-->
                                <WarningColor>
                                    <div
                                        style="font-size: 14px; text-transform: uppercase;border-bottom-style: dotted; font-weight: 600;"
                                    >
                                        {$_('Tryb podglądu')}
                                    </div>
                                </WarningColor>
                                <!--                                </span>-->
                                <!--                                <ButtonSmallBlueRounded-->
                                <!--                                    text={$_('Zapisz jako własny')}-->
                                <!--                                    on:click={() => {-->
                                <!--                                        saveAsOwnTemplate();-->
                                <!--                                    }}-->
                                <!--                                />-->
                            {/if}
                        {/if}
                        {#if $debug}
                            <div style="font-size:10px;">
                                {JSON.stringify($filter.dashboard)}<br />
                                {JSON.stringify(widgetTemplateList.getCurrentTemplateId())}<br />
                                {JSON.stringify(widgetManager.getComponentIds())}<br />
                                {currentDashboardKey}
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
            <div slot="main-search"></div>
            <div
                slot="main-buttons"
                style="display:flex; align-items: center; column-gap: 25px;"
            ></div>
        </TemplateHeaderTrio>
    </div>
    <!--    overflow-y: auto;-->
    <div slot="content-header">
        <div
            style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; padding: 20px 20px 0px 20px;"
            class:invisible={widgetTemplateList.getCurrentTemplateId() === null ||
                widgetManager.getComponents().length === 0}
        >
            {#if !loadingCurrentDashboard}
                <div style="">
                    <DashboardFilter {widgetManager} {onChangeFilters} />
                </div>
            {/if}
        </div>
    </div>
    <div slot="content">
        <div
            style="display: flex; flex-direction: column; margin-top:20px; margin-bottom: 40px;"
            class:disabled={loadingCurrentDashboard}
        >
            {#if widgetTemplateList.getCurrentTemplateId() === null && !loadingCurrentDashboard}
                <div class="center-content">
                    <div style="display: flex; align-items: center; column-gap: 25px;">
                        <ButtonMain
                            text={$_('Utwórz pierwszy widok')}
                            disabled={loadingCurrentDashboard}
                            on:click={() => {
                                createFirstTemplate();
                            }}
                        />
                    </div>
                </div>
            {:else}
                <WidgetList bind:widgetManager {addWidget} />
            {/if}
        </div>
    </div>
    <div slot="footer"></div>
</TemplateStandard>

<style>
    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    .invisible {
        visibility: hidden;
    }
    .center-content {
        display: flex;
        flex-direction: row;
        margin-top: 20px;
        margin-bottom: 40px;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-content: center;
        min-height: 300px;
    }
</style>
